<div class="container-fluid">
  <!-- Header Section -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h2 class="mb-2">{{ title }}</h2>
              <p class="text-muted mb-0">{{ subtitle }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Card -->
  <div class="card position-relative">
    <!-- Loading Overlay -->
    <div class="text-center position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style="background: rgba(255,255,255,0.6); z-index: 10;" *ngIf="loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="card-body m-0">

      <!-- Filters -->
      <div class="row mt-2">
        <div class="col-md-3">
          <label class="col-form-label" for="walletLedgerDate">Date</label>
          <input class="form-control" id="walletLedgerDate" type="date" [(ngModel)]="selectedDate" />
        </div>

        <div class="col-md-3">
          <label class="col-form-label" for="walletLedgerType">Wallet Type</label>
          <ng-select id="walletLedgerType" placeholder="All" [(ngModel)]="selectedWalletType" [clearable]="true">
            <ng-option *ngFor="let option of walletTypeOptions" [value]="option.value">
              {{ option.label }}
            </ng-option>
          </ng-select>
        </div>

        <div class="col-md-3">
          <label class="col-form-label" for="walletLedgerMobile">Mobile Number</label>
          <input class="form-control" id="walletLedgerMobile" type="text" [(ngModel)]="mobileNumber"
            placeholder="Enter mobile number" />
        </div>

        <div class="col-md-3">
          <label class="col-form-label" for="walletLedgerTrxType">Transaction Type</label>
          <input class="form-control" id="walletLedgerTrxType" type="text" [(ngModel)]="trxType"
            placeholder="Enter transaction type" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-md-3">
          <label class="col-form-label" for="walletLedgerStatus">Status</label>
          <ng-select id="walletLedgerStatus" placeholder="All" [(ngModel)]="selectedStatus" [clearable]="true">
            <ng-option *ngFor="let option of statusOptions" [value]="option.value">
              {{ option.label }}
            </ng-option>
          </ng-select>
        </div>

        <div class="col-md-3">
          <label class="col-form-label" for="walletLedgerDebitCredit">Credit / Debit</label>
          <ng-select id="walletLedgerDebitCredit" placeholder="All" [(ngModel)]="selectedDebitCredit" [clearable]="true">
            <ng-option *ngFor="let option of debitCreditOptions" [value]="option.value">
              {{ option.label }}
            </ng-option>
          </ng-select>
        </div>

        <div class="col-md-6 d-flex align-items-end gap-2">
          <button type="button" class="btn bg-danger-custom" (click)="onSearch()">
            <i class="feather icon-search me-2"></i>Search
          </button>
          <button type="button" class="btn bg-secondary" (click)="onReset()">
            <i class="feather icon-refresh-cw me-2"></i>Reset
          </button>
        </div>
      </div>

      <!-- Action Buttons Row -->
      <div class="row mt-3 mb-2">
        <div class="col-xl-12">
          <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()" [disabled]="loading">
            <i class="feather icon-download me-2"></i>Export CSV
          </button>
        </div>
      </div>

      <!-- Grid Container -->
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (gridReady)="onGridReady($event)"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="'clientSide'" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>

      <!-- Pagination and Page Size Row -->
      <div class="row mt-0">
        <div class="col-4 col-xs-4 d-flex">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
          </select>
          <p class="text-muted p-3">Total Records: {{ collectionSize }}</p>
        </div>

        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
            [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
